//#region src/nullToUndefined.ts
/**
* Converts a value of `T | null | undefined` to just `T | undefined` by converting the `null` value to `undefined`.
*
* When a non-required field is unset in Contentful, its value is returned as null. However, this
* can end up overriding default values for non-required properties on the underlying components.
* This function returns undefined when passed null, otherwise it returns the given argument.
*
* @category Utilities
*/
function nullToUndefined(val) {
	return val === null ? void 0 : val;
}
var nullToUndefined_default = nullToUndefined;

//#endregion
export { nullToUndefined_default };